<template>
  <v-runtime-template :template="includeTemp"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'

export default {
  name: 'CommpnPopup',
  components: {
    VRuntimeTemplate
  },
  props: {
  },
  data () {
    return {
      includeHtml: ''
    }
  },
  computed: {
    includeTemp () {
      return this.includeHtml
    }
  },
  mounted () {
  },
  async created () {
    this.getEmptyTemplate('wepPrivacyPolicy' + this.$route.params.obj + '.html')
  },
  methods: {
    getEmptyTemplate (resourceUrl, next) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.firstSubTemplate = res
        this.includeHtml = wepHtmlToString.firstSubTemplate
      })
    },
    closePopup () {
      window.close()
    },
    close () {
      window.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/CommonPopup.vue